const prefix = 'articles'

export const ArticlesQueryKeys = {
  Announcement: `${prefix}/announcement`,
  Announcements: `${prefix}/announcements`,
  UnreadAnnouncements: `${prefix}/unread-announcements`,
  UnreadTrainingMaterialsCount: `${prefix}/unread-training-materials-count`,
  ContentTrainingMaterials: `${prefix}/content-training-materials`,
  ContentTrainingMaterial: `${prefix}/content-training-material`,
  ContentTrainingMaterialUsers: `${prefix}/content-training-material-users`,
  TrainingMaterials: `${prefix}/training-materials`,
  TrainingMaterial: `${prefix}/training-material`,
} as const
